<div class="inicio">

    <!--TITULO-->
    <div>
        <br>
        <p class="titulo">
            PROGRAMAR MANTENIMIENTO
            <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
                <mat-icon>info</mat-icon> 
            </button>
        </p>
        <br>
    </div>

    <!--CUERPO-->
    <div class="columnas_3_filas_2">
        

        <div class="celda">
            <mat-label class="label">Sucursal <mat-label class="advertencia">*</mat-label> </mat-label>
            <!--<mat-form-field class="example-full-width" appearance="fill" floatLabel="always">
                <input type="text" matInput [formControl]="input_sucursal_nombre" [matAutocomplete]="auto" oninput="this.value = this.value.toUpperCase()" required>
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="clickCargarSucursal($event.option.value)">
                <mat-option *ngFor="let option of listaFiltradaSucursales | async" [value]="option"> {{option.nombreSucursal}} </mat-option>
                </mat-autocomplete>
            </mat-form-field>-->

            <mat-form-field appearance="fill">
                <mat-select [formControl]="input_sucursal" #singleSelect1 (selectionChange)="clickCargarSucursal($event)">
                <mat-option>
                    <ngx-mat-select-search [formControl]="input_sucursal_nombre" oninput="this.value = this.value.toUpperCase()"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let option of listaFiltradaSucursales | async" [value]="option"> 
                    {{option.nombreSucursal}} 
                </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        

        <div class="celda">
            <mat-label class="label">Fecha para agendar <mat-label class="advertencia">*</mat-label> </mat-label>
            <mat-form-field class="example-full-width" appearance="fill" floatLabel="always">
                <input matInput [matDatepicker]="picker" [min]="fecha" [formControl]="fecha_agend">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="celda">
            <mat-label class="label">Comentarios u observaciones</mat-label>
            <mat-form-field class="example-full-width" appearance="fill" floatLabel="always">
                <input matInput type="text" [formControl]="observ_generales">
            </mat-form-field>
        </div>
    </div>

    <!--TABLA  bandera-->
    <div class="grid-container">
        <div>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                
                <ng-container matColumnDef="OPCIONES">
                    <th mat-header-cell *matHeaderCellDef> 
                        <mat-checkbox class="example-margin" (change)="checkAll($event.checked)" ></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox class="example-margin" [(ngModel)]="element.bandera" ></mat-checkbox>        
                    </td>
                </ng-container>

                <ng-container matColumnDef="NOMBRE DEL EQUIPO">
                    <th mat-header-cell *matHeaderCellDef> NOMBRE DEL EQUIPO </th>
                    <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
                </ng-container>
            
                <ng-container matColumnDef="ESTADO">
                    <th mat-header-cell *matHeaderCellDef> ESTADO </th>
                    <td mat-cell *matCellDef="let element"> {{ element.states_id }} </td>
                </ng-container>
            
                <ng-container matColumnDef="USUARIO RESPONSABLE">
                    <th mat-header-cell *matHeaderCellDef> USUARIO RESPONSABLE </th>
                    <td mat-cell *matCellDef="let element"> {{ element.users_id }} </td>
                </ng-container>
            
                <ng-container matColumnDef="TIPO">
                    <th mat-header-cell *matHeaderCellDef> TIPO </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.tipo }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="MODELO">
                    <th mat-header-cell *matHeaderCellDef> MODELO </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.modelo }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="COMENTARIOS">
                    <th mat-header-cell *matHeaderCellDef> COMENTARIOS </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.comment }}
                    </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
                <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>
            </table>
            <mat-paginator #paginator class="mat-elevation-z8" [pageSize]="10" showFirstLastButtons></mat-paginator>
        </div>
    </div>

    <!--BOTONES-->
    <br>
    <div class="columnas_5">
        <button mat-raised-button matTooltip="Sale sin guardar la información" color="warn" (click)="clickCancelar($event)" >Cancelar <mat-icon>cancel</mat-icon> </button>
        <div></div>
        <div></div>
        <div></div>
        <button mat-raised-button matTooltip="Guarda el mantenimiento programado" [disabled]="!habilitarBotonAgendar()" (click)="clickAgendar($event)" color="primary">Agendar <mat-icon>save</mat-icon> </button>
    </div>
</div>